import { useAuth } from '@/lib/auth-store';
import { FeaturesOwner } from './FeaturesOwner';
import { FeaturesReseller } from './FeaturesReseller';
import { Navigate } from 'react-router-dom';

/**
 * Single `/settings/features` URL — selects the right view by role so each
 * tier sees the scope-appropriate layout without leaking the owner catalog
 * to resellers or resellers' price-to-reseller setting to customers.
 *
 * 2026-08-06 (Sam): customer-tier roles (office_manager / standard_user /
 * limited_user) have NO feature-flags view at all anymore. Features are
 * billable and reseller-controlled — the customer self-service editor
 * (FeaturesCustomer) was removed, and the backend customerMutateGate no
 * longer accepts office_manager. Per-customer flags are managed by the
 * reseller / super-admin from the customer's detail page (/customers/:id →
 * Features card). This in-page role check is belt-and-suspenders under the
 * route gate in router.tsx.
 */
export function FeaturesPage() {
  const user = useAuth((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;
  if (user.is_super_admin) return <FeaturesOwner />;
  if (user.role === 'reseller_owner' || user.role === 'agent') return <FeaturesReseller />;
  // Customer-tier and any other role: nothing to see here.
  return <Navigate to="/dashboard" replace />;
}
